export default "__VITE_ASSET__CXig10q7__"